// AUTO-GENERATED FILE - DO NOT EDIT MANUALLY
// Generated by scripts/fetch-custom-models.ts at build time.
import type { CustomModelType } from "@app/types/assistant/models/custom_models";
import type { ModelConfigurationType } from "@app/types/assistant/models/types";

// Literal ids, so custom models extend the `ModelIdType` and `Model` unions.
export const CUSTOM_MODEL_IDS = [] as const;

// Cast needed because `ModelConfigurationType.modelId` is the model id union.
export const CUSTOM_MODELS = [] as unknown as CustomModelType[];

export const CUSTOM_MODEL_CONFIGS: ModelConfigurationType[] = CUSTOM_MODELS.map(
  ({ modelConfig }) => modelConfig
);
